const tips = [
  {
    icon: 'ri-leaf-line',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    title: 'Privilégiez les fibres',
    description: 'Les fibres ralentissent l\'absorption des glucides et stabilisent votre glycémie. Visez 25-30g de fibres par jour.',
  },
  {
    icon: 'ri-time-line',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    title: 'Timing de l\'insuline',
    description: 'Avec une boucle fermée, anticipez votre repas de 15-20 minutes pour un meilleur contrôle glycémique post-prandial.',
  },
  {
    icon: 'ri-scales-line',
    color: 'text-sky-600',
    bg: 'bg-sky-50',
    title: 'Pesez vos aliments',
    description: 'La précision est clé pour les DT1. Utilisez une balance de cuisine pour des calculs glucidiques exacts.',
  },
  {
    icon: 'ri-bar-chart-line',
    color: 'text-violet-600',
    bg: 'bg-violet-50',
    title: 'Index glycémique',
    description: 'Préférez les aliments à index glycémique bas (&lt;55) pour des glycémies plus stables et prévisibles.',
  },
  {
    icon: 'ri-water-flash-line',
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    title: 'Hydratation',
    description: 'Buvez suffisamment d\'eau (1,5-2L/jour). La déshydratation peut fausser les lectures de glycémie.',
  },
  {
    icon: 'ri-heart-line',
    color: 'text-rose-600',
    bg: 'bg-rose-50',
    title: 'Oméga-3 protecteurs',
    description: 'Les poissons gras (saumon, maquereau) apportent des oméga-3 bénéfiques pour la santé cardiovasculaire des DT1.',
  },
];

export default function BonusSection() {
  return (
    <section id="bonus" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-amber-50 text-amber-600 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Bonus Intelligent
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Conseils pour les diabétiques de type 1
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Des recommandations pédagogiques adaptées à votre vie avec une boucle fermée.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="flex gap-4 p-5 bg-gray-50 rounded-2xl border border-gray-100 hover:border-teal-200 transition-all duration-200"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${tip.bg} shrink-0`}>
                <i className={`${tip.icon} ${tip.color} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 text-sm mb-1">{tip.title}</h3>
                <p
                  className="text-gray-500 text-sm leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: tip.description }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Medical disclaimer */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 flex gap-4">
          <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl shrink-0">
            <i className="ri-stethoscope-line text-amber-600 text-xl"></i>
          </div>
          <div>
            <h4 className="font-semibold text-amber-800 mb-1">Avertissement médical important</h4>
            <p className="text-amber-700 text-sm leading-relaxed">
              DT1 Simply Menu est un outil d&apos;aide à la gestion des glucides. Il ne remplace en aucun cas l&apos;avis de votre médecin, diabétologue ou diététicien. Consultez toujours votre équipe médicale pour adapter votre traitement et votre alimentation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
